export const EDocDocumentType = {
  "0": "UNKNOWN",
  "1": "PNR_DOC",
  "2": "PNR_OFFER",
  "3": "INVOICE",
  "4": "PNR_CONFIRM",
  "5": "VOUCHER_DOC",
  "6": "TNR_DOC",
  "7": "VOUCHER_OFFER",
  "8": "DOCGEN_VERSION",
  "9": "RNR_DOC",
  "10": "HOTEL_RESERVATION_DOC",
  "11": "HOTEL_REISSUE_DOC",
  "12": "HOTEL_REVERSE_DOC",
  "13": "HOTEL_AGENCY_NOTE",
  "-1": "ALL"
};

export const EDocFileType = {
  "0": "UNKNOWN",
  "1": "HTML",
  "2": "PDF",
  "-1": "ALL"
};

export const EDocFontType = {
  "0": "UNKNOWN",
  "1": "BOLD",
  "2": "ITALIC",
  "-1": "ALL"
};